module.exports = __webpack_public_path__ + "static/media/ore1.png.ca2ac5e8.jpg";